import React, { useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, ShieldCheck, Scissors } from 'lucide-react';
import { Button, Sticker } from './ui';
import { useCheckout } from './checkout-context';
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 5,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex justify-center gap-4 mb-8" data-id="element-248">
      {[{
      label: 'Horas',
      value: format(timeLeft.hours)
    }, {
      label: 'Minutos',
      value: format(timeLeft.minutes)
    }, {
      label: 'Segundos',
      value: format(timeLeft.seconds)
    }].map((block, i) => <div key={i} className="flex flex-col items-center" data-id="element-249">
          <div className="bg-white text-brand-navy font-heading text-3xl md:text-4xl w-16 h-16 md:w-20 md:h-20 rounded-xl flex items-center justify-center shadow-lg mb-2" data-id="element-250">
            {block.value}
          </div>
          <span className="text-white/80 text-xs md:text-sm font-medium uppercase tracking-wider" data-id="element-251">
            {block.label}
          </span>
        </div>)}
    </div>;
};
const InlineOrderBump = () => {
  const {
    orderBumpChecked: checked,
    setOrderBumpChecked: setChecked
  } = useCheckout();
  return <div className="relative mt-6 mb-8" data-id="element-252">
      {!checked && <div className="absolute -top-3 left-4 bg-brand-pink text-white text-xs font-bold px-3 py-1 rounded-full shadow-md transform -rotate-2 animate-pulse z-20 whitespace-nowrap" data-id="element-253">
          ⭐ OFERTA ÚNICA — AGREGA AHORA
        </div>}
      <div className={`relative rounded-2xl border-4 border-dashed p-5 md:p-6 text-left overflow-hidden bg-white ${checked ? 'border-brand-green' : 'order-bump-flash'}`} data-id="element-254">
        {!checked && <div className="absolute inset-0 flash-stripe pointer-events-none rounded-2xl" data-id="element-255" />}

        <label className="flex flex-col md:flex-row gap-4 items-center cursor-pointer group relative z-10" data-id="element-256">
          <img src="https://cdn.shopify.com/s/files/1/0999/7487/3381/files/Recorta_arma_y_pega.png?v=1780592902&width=300&quality=80&format=webp" alt="Recorta, arma y pega" width="300" height="300" loading="lazy" decoding="async" className="w-24 md:w-28 h-auto object-contain drop-shadow-lg flex-shrink-0" data-id="element-257" />

          <div className="flex-1 text-center md:text-left" data-id="element-258">
            <div className="flex items-center gap-2 mb-1 justify-center md:justify-start" data-id="element-259">
              <Scissors className="w-4 h-4 text-brand-pink" data-id="element-260" />
              <span className="text-xs uppercase font-bold tracking-wider text-brand-pink" data-id="element-261">
                ¡Sumá un regalo extra!
              </span>
            </div>
            <h4 className="font-heading text-xl md:text-2xl text-brand-navy mb-1" data-id="element-262">
              RECORTA, ARMA Y PEGA
            </h4>
            <p className="text-sm text-slate-600 mb-2" data-id="element-263">
              62 páginas extra de actividades de recorte y armado.
            </p>
            <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-264">
              <span className="text-slate-400 line-through text-sm" data-id="element-265">
                $19.999
              </span>
              <span className="text-brand-pink font-bold text-lg" data-id="element-266">
                + $9.999
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-2" data-id="element-267">
            <div className={`relative w-14 h-14 rounded-xl border-2 flex items-center justify-center transition-all ${checked ? 'bg-brand-green border-brand-green scale-105 shadow-lg' : 'bg-brand-yellow/40 border-brand-pink shadow-[0_0_0_4px_rgba(255,77,141,0.15)] group-hover:bg-brand-yellow/70'}`} data-id="element-268">
              {checked ? <ShieldCheck className="w-8 h-8 text-white" data-id="element-269" /> : <>
                  <span className="absolute inset-0 rounded-xl border-2 border-brand-pink animate-ping opacity-60" data-id="element-270" />
                  <span className="text-2xl" data-id="element-271">👆</span>
                </>}
            </div>
            <input type="checkbox" className="hidden" checked={checked} onChange={() => setChecked(!checked)} data-id="element-272" />
            <span className={`text-xs font-bold select-none whitespace-nowrap px-2 py-0.5 rounded-full ${checked ? 'text-brand-green' : 'text-white bg-brand-pink'}`} data-id="element-273">
              {checked ? '¡Agregado!' : 'Toca aquí'}
            </span>
          </div>
        </label>
      </div>
    </div>;
};
export const Offer = () => {
  const {
    orderBumpChecked,
    requestCheckout
  } = useCheckout();
  const totalPrice = orderBumpChecked ? '$31.998' : '$21.999';
  return <section id="oferta" className="py-24 relative overflow-hidden bg-brand-navy" data-id="element-274">
      {/* Radial Gradient Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(45,140,255,0.3)_0%,transparent_70%)]" data-id="element-275" />

      <Sticker type="sparkle" className="top-20 left-10 md:left-32" delay={0.2} data-id="element-276" />
      <Sticker type="star" className="bottom-20 right-10 md:right-32" delay={0.5} data-id="element-277" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-278">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="inline-block bg-brand-pink text-white font-bold px-6 py-2 rounded-full text-lg mb-8 transform -rotate-3 shadow-pink" data-id="element-279">
          🔥 OFERTA SOLO POR HOY
        </motion.div>

        <h2 className="font-heading text-5xl md:text-6xl text-white mb-12" data-id="element-280">
          Oferta de Lanzamiento
        </h2>

        <CountdownTimer data-id="element-281" />

        <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 md:p-10 border border-white/20 shadow-2xl max-w-2xl mx-auto" data-id="element-282">
          <div className="mb-4" data-id="element-283">
            <span className="text-white/70 text-xl font-medium" data-id="element-284">
              Valor Real:{' '}
            </span>
            <span className="text-white/50 text-2xl line-through font-bold" data-id="element-285">
              $360.000
            </span>
          </div>

          <div className="mb-2" data-id="element-286">
            <span className="text-brand-yellow font-bold text-2xl tracking-widest uppercase" data-id="element-287">
              Hoy Solo
            </span>
          </div>

          <div className="relative h-24 md:h-32 mb-6 flex items-center justify-center" data-id="element-288">
            <AnimatePresence mode="wait" data-id="element-289">
              <motion.div key={totalPrice} initial={{
              opacity: 0,
              scale: 0.7,
              y: 20
            }} animate={{
              opacity: 1,
              scale: 1,
              y: 0
            }} exit={{
              opacity: 0,
              scale: 0.7,
              y: -20
            }} transition={{
              type: 'spring',
              stiffness: 200,
              damping: 18
            }} className="font-heading text-7xl md:text-8xl text-brand-pink drop-shadow-[0_4px_20px_rgba(255,77,141,0.5)] absolute" data-id="element-290">
                {totalPrice}
              </motion.div>
            </AnimatePresence>
          </div>

          {orderBumpChecked && <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-brand-yellow text-sm font-semibold mb-6" data-id="element-291">
              ✨ Incluye Kit + Recorta, Arma y Pega
            </motion.div>}

          {/* Inline Order Bump with flash effect */}
          <InlineOrderBump data-id="element-292" />

          <Button size="xl" onClick={requestCheckout} className="w-full md:w-auto text-xl md:text-2xl py-6 px-12 group" data-id="element-293">
            <ShoppingCart className="w-8 h-8 mr-3 group-hover:scale-110 transition-transform" data-id="element-294" />
            QUIERO APROVECHAR LA OFERTA
          </Button>

          <div className="mt-6 bg-white rounded-2xl p-3 shadow-lg max-w-md mx-auto" data-id="element-295">
            <img src="https://cdn.magicpatterns.com/uploads/hFPy15jHvdzM7weE1CVTJX/MERCADOLIDER.jpg" alt="Pago seguro garantizado — Visa, Mastercard, Maestro, Mercado Pago. MercadoLíder Platinum." width="600" height="600" loading="lazy" decoding="async" className="w-full h-auto rounded-xl" data-id="element-296" />
          </div>

          <p className="text-white/60 text-sm mt-4 flex items-center justify-center gap-2" data-id="element-297">
            🔒 Pago 100% seguro y encriptado
          </p>
        </div>
      </div>
    </section>;
};